import { render, staticRenderFns } from "./PayoutSettings.vue?vue&type=template&id=88fdc6d8"
import script from "./PayoutSettings.vue?vue&type=script&lang=js"
export * from "./PayoutSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports